import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { DynamicOptionsComponent } from '../dynamic-options';
import { ActionListsSelectorService } from '../../../../../../data-services/action-lists-selector-service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AutomationReplacementChipsComponent } from '../../../../../../common/components/automation-replacement-chips/automation-replacement-chips.component';

@Component({
  selector: 'automata-list-options',
  templateUrl: './list-options.component.html',
  styleUrls: ['./list-options.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationReplacementChipsComponent,
  ],
})
export class ListOptionsComponent implements OnInit, DynamicOptionsComponent {
  actionListsSelectorService = inject(ActionListsSelectorService);

  listOptionsControl: UntypedFormControl = new UntypedFormControl([], listsValidator);
  //Account Group stores only the list names so that's all we care about

  @Input() initialValue: string[];
  selectedValue$ = this.listOptionsControl.valueChanges;
  ngOnInit(): void {
    if (Array.isArray(this.initialValue)) {
      this.listOptionsControl.setValue(this.initialValue);
    }
  }

  getSelectedValue(): string[] {
    return this.listOptionsControl?.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.listOptionsControl];
  }

  isFormValid(): boolean {
    return this.listOptionsControl.valid;
  }
}

function listsValidator(control: AbstractControl): { [key: string]: any } {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { error: false };
}
